import axios from 'axios';

import { AuthInterceptor, AuthService, AuthTokenService } from '@sine/auth-client';

import { AuthHelpers } from '../helpers/auth.helpers';
import { sessionStorage, storage } from '../services/storage/storage.service';
import deviceService from './device.service';

const authService = new AuthService({
  authApiUrl: window.env.REACT_APP_SINE_ID_API_URI,
  coreAuthApiUrl: window.env.REACT_APP_SINE_CORE_API_URI,
  rootClientUrl: `${window.location.origin}${window.env.PUBLIC_URL}`,
  // Only used for device-based authentication, which Core Client doesn't support
  rootClientAuthApiUrl: window.env.REACT_APP_SINE_ID_API_URI,
  storage,
  sessionStorage,
  axiosInstance: axios,
});

export const authTokenService = new AuthTokenService(storage, sessionStorage);
export const authHelpers = new AuthHelpers(authService);

const authInterceptor = new AuthInterceptor(axios, authService);
authInterceptor.startIntercepting();
authHelpers.initialiseEvents();

/**
 * Wait until the device service has grabbed itself a token and then attempt
 * to initialise the auth service!
 */
let registeredDeviceToken: string | undefined;
function handleDeviceTokenChanged(newDeviceToken: string | undefined) {
  if (registeredDeviceToken && registeredDeviceToken !== newDeviceToken) {
    // Authentication previously performed with different device token, nothing we can do here.
    registeredDeviceToken = undefined;

    authService.trashUser();
  } else if (newDeviceToken) {
    // Device token is ready, let's try and initialise
    registeredDeviceToken = newDeviceToken;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authService.initialize();
  }
}

handleDeviceTokenChanged(deviceService.getDeviceToken());
deviceService.addDeviceTokenListener(handleDeviceTokenChanged);

export default authService;
